import { createSelector } from 'reselect'
import getCanRedeemTransferLoyaltyBenefit from './getCanRedeemTransferLoyaltyBenefit'
import getCanRedeemLoungePassLoyaltyBenefit from './getCanRedeemLoungePassLoyaltyBenefit'
import getCanRedeemStayUpgradeLoyaltyBenefit from './getCanRedeemStayUpgradeLoyaltyBenefit'
import getCanShowCheckoutLoyaltyEsimBenefit from './getCanShowCheckoutEsimBenefit'
import getLoyaltyLoungePassItemViews from '../view/itemViews/getLoyaltyLoungePassItemViews'
import { getIsBookingOwnerForCheckoutOrder } from 'luxPlus/selectors/featureToggle'

const getCanRedeemCheckoutLoyaltyBenefits = createSelector(
  (state: App.State) => getIsBookingOwnerForCheckoutOrder(state),
  (state: App.State) => getCanRedeemTransferLoyaltyBenefit(state),
  (state: App.State) => getCanRedeemLoungePassLoyaltyBenefit(state),
  (state: App.State) => getCanRedeemStayUpgradeLoyaltyBenefit(state),
  (state: App.State) => getLoyaltyLoungePassItemViews(state),
  (state: App.State) => getCanShowCheckoutLoyaltyEsimBenefit(state),
  (isBookingOwner, canRedeemTransfers, canRedeemLoungePasses, canRedeemRoomUpgradeLoyaltyBenefit, loyaltyLoungePassItemViews, canShowEsim): boolean => {
    if (!isBookingOwner) return false

    const hasPreselectedLoungePasses = loyaltyLoungePassItemViews.data.length > 0
    return canRedeemLoungePasses || hasPreselectedLoungePasses || canRedeemTransfers || canRedeemRoomUpgradeLoyaltyBenefit || canShowEsim
  },
)

export default getCanRedeemCheckoutLoyaltyBenefits
